import { DEFAULT_LOCATIONS, HOUSTON_METHODIST, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 20da2687b61b4cc2965eb17a4a9ce588672f43dc',
  staging: 'Token c66c246313216d56623ae9d5e23354ca2db4e2a5',
  prod: 'Token 7b60f2069d2358e3a54d0360e559b8b9e7fdaad7',
};

const token = selectToken(apiTokens);

const houstonMethodistConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'houstonmethodist',

  API_TOKEN: token,
  EMBOLD_CLIENT: HOUSTON_METHODIST,

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Houston },
  LOGIN_NETWORK_NAME: 'houstonMethodistUserId',

  // content
  DISPLAY_NAME: 'Houston Methodist',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default houstonMethodistConfig;
